import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './../../assets/main-icon-white.png'
import _imports_1 from './../../assets/user-icon.png'


const _withScopeId = n => (_pushScopeId("data-v-2d79f238"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "MainMenu-container" }
const _hoisted_2 = { class: "MainMenu-row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "MainMenu-logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "MainMenu-logo-icon",
    src: _imports_0,
    alt: "icon"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "MainMenu-logo-text" }, "Opti-Loading")
], -1))
const _hoisted_4 = { class: "MainMenu-menu" }
const _hoisted_5 = { class: "MainMenu-profile" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode()
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = { class: "MainMenu-profile-productVersion" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxMenu = _resolveComponent("DxMenu")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxPopover = _resolveComponent("DxPopover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_DxMenu, {
          "data-source": _ctx.tabs,
          "show-first-submenu-mode": _ctx.showFirstSubmenuModes,
          orientation: _ctx.orientation,
          "adaptivity-enabled": _ctx.adaptivityEnabled,
          "submenu-direction": _ctx.submenuDirection,
          "hide-submenu-on-mouse-leave": _ctx.hideSubmenuOnMouseLeave,
          "display-expr": "name",
          height: "100%",
          onItemClick: _ctx.click
        }, null, 8, ["data-source", "show-first-submenu-mode", "orientation", "adaptivity-enabled", "submenu-direction", "hide-submenu-on-mouse-leave", "onItemClick"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("img", {
          id: "user",
          class: "MainMenu-profile-icon",
          src: _imports_1,
          alt: "icon",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toogleUserPopover && _ctx.toogleUserPopover(...args)))
        }),
        _createVNode(_component_DxPopover, {
          width: 250,
          visible: _ctx.userPopoverVisible,
          target: "#user",
          position: "bottom",
          onHidden: _ctx.onUserPopoverHidden
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", null, [
              _createElementVNode("strong", {
                class: "MainMenu-profilePopover-userName",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.profile && _ctx.profile(...args)))
              }, _toDisplayString(_ctx.userName), 1),
              _hoisted_6,
              _createElementVNode("span", null, _toDisplayString(_ctx.userFullName), 1),
              _hoisted_7,
              _hoisted_8,
              _hoisted_9,
              _createElementVNode("span", _hoisted_10, "Opti-Loading версия " + _toDisplayString(_ctx.productVersion), 1)
            ]),
            _createElementVNode("div", {
              class: "dx-icon-close MainMenu-profilePopover-closeButton",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toogleUserPopover && _ctx.toogleUserPopover(...args)))
            }),
            _createVNode(_component_DxButton, {
              class: "MainMenu-profilePopover-exitButton",
              text: "Выход",
              hint: "Выход",
              type: "default",
              "styling-mode": "outlined",
              onClick: _ctx.logOut,
              width: 80,
              height: 30
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["visible", "onHidden"])
      ])
    ])
  ]))
}